import { useState } from "react";

const DISMISS_KEY = "release-env-banner-dismissed";

// Shown only on the release environment (REACT_APP_STAGE === "release" at build
// time). Release data is a copy of production, but the environment talks to
// HyperComply staging, so production-copied vendors are not usable end-to-end.
const ReleaseEnvironmentBanner = () => {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === "true"
  );

  if (dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "true");
    setDismissed(true);
  };

  return (
    <div className="w-full bg-amber-100 border-b border-amber-300 text-amber-900 text-sm px-4 py-2 flex items-center justify-center gap-3">
      <span>
        <strong>Test environment:</strong> this data is a copy of production
        and is not connected to HyperComply. Vendors copied from production
        cannot be used for questionnaires, and new vendors need a name, email,
        and website domain that no existing vendor already uses.
      </span>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Dismiss test environment notice"
        className="shrink-0 font-bold text-amber-900 hover:text-amber-600"
      >
        ✕
      </button>
    </div>
  );
};

export default ReleaseEnvironmentBanner;
